export default class Queue {
  constructor() {
    this.queue = [];
    this.workingOnPromise = false;
  }

  enqueue(id, promise) {
    console.log('enqueue %s.', id);
    return new Promise((resolve, reject) => {
      this.queue.push({
        promise,
        resolve,
        reject,
        id,
      });
      console.log('Queue size: %d', this.queue.length);
      this.dequeue();
    });
  }

  dequeue() {
    if (this.workingOnPromise) {
      return false;
    }
    const item = this.queue.shift();
    console.log('Next task: ', item);
    if (!item) {
      return false;
    }
    try {
      this.workingOnPromise = true;
      item.promise()
        .then((value) => {
          this.workingOnPromise = false;
          item.resolve(value);
          this.dequeue();
        })
        .catch(err => {
          this.workingOnPromise = false;
          item.reject(err);
          this.dequeue();
        });
    } catch (err) {
      this.workingOnPromise = false;
      item.reject(err);
      this.dequeue();
    }
    return true;
  }

  removeItem(id) {
    console.log('Remove %s from queue', id);
    const item = this.queue.find(i => i.id === id);
    if (item) {
      const idx = this.queue.indexOf(item);
      this.queue.splice(idx, 1);
      console.log('Queue size: %d', this.queue.length);
    } else {
      console.log('Item %s not found in queue', id);
    }
  }

  clear() {
    this.queue.length = 0;
    this.workingOnPromise = false;
  }
}